import React, { useState, useEffect } from 'react';
import api from '../services/api';

const ApiDebugTool = () => {
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [endpoint, setEndpoint] = useState('/api/v1/admin/vehicles');
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [showRawResponse, setShowRawResponse] = useState(false);

  const testEndpoint = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get(endpoint);
      console.log('API Debug Response:', response.data);
      setApiResponse(response.data);
    } catch (error) {
      console.error('API Debug Error:', error);
      setError(error.message || 'An error occurred');
      if (error.response) {
        console.error('Error response:', error.response.data);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    try {
      const response = await api.post('/api/v1/auth/login', {
        email: 'admin@example.com',
        password: 'password'
      });
      
      console.log('Login response:', response.data);
      
      if (response.data.success && response.data.data && response.data.data.token) {
        setToken(response.data.data.token);
        localStorage.setItem('token', response.data.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        alert('Login successful');
      } else if (response.data.token) {
        setToken(response.data.token);
        localStorage.setItem('token', response.data.token);
        alert('Login successful');
      } else {
        alert('Login failed: ' + (response.data.message || 'Unknown error'));
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('Login failed: ' + (error.message || 'Unknown error'));
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">API Debug Tool</h1>
      
      <div className="bg-white shadow-md rounded p-4 mb-4">
        <h2 className="text-xl font-semibold mb-2">Authentication</h2>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            JWT Token
          </label>
          <input
            type="text"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="JWT Token"
          />
        </div>
        <button
          onClick={() => {
            localStorage.setItem('token', token);
            alert('Token saved to localStorage');
          }}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
        >
          Save Token
        </button>
        <button
          onClick={handleLogin}
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
        >
          Login as Admin
        </button>
      </div>
      
      <div className="bg-white shadow-md rounded p-4 mb-4">
        <h2 className="text-xl font-semibold mb-2">API Endpoint Test</h2>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Endpoint
          </label>
          <input
            type="text"
            value={endpoint}
            onChange={(e) => setEndpoint(e.target.value)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="API Endpoint (e.g., /api/v1/admin/vehicles)"
          />
        </div>
        <button
          onClick={testEndpoint}
          disabled={loading}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          {loading ? 'Testing...' : 'Test Endpoint'}
        </button>
      </div>
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <strong className="font-bold">Error: </strong>
          <span className="block sm:inline">{error}</span>
        </div>
      )}
      
      {apiResponse && (
        <div className="bg-white shadow-md rounded p-4">
          <h2 className="text-xl font-semibold mb-2">API Response</h2>
          <div className="mb-2">
            <button
              onClick={() => setShowRawResponse(!showRawResponse)}
              className="text-blue-500 hover:text-blue-700"
            >
              {showRawResponse ? 'Show Formatted' : 'Show Raw'}
            </button>
          </div>
          
          {showRawResponse ? (
            <pre className="bg-gray-100 p-4 rounded overflow-x-auto">
              {JSON.stringify(apiResponse, null, 2)}
            </pre>
          ) : (
            <div>
              <div className="mb-4">
                <h3 className="font-bold">Success:</h3>
                <p>{apiResponse.success ? 'Yes' : 'No'}</p>
              </div>
              
              <div className="mb-4">
                <h3 className="font-bold">Message:</h3>
                <p>{apiResponse.message || 'No message'}</p>
              </div>
              
              {apiResponse.data && (
                <div>
                  <h3 className="font-bold mb-2">Data:</h3>
                  
                  {Array.isArray(apiResponse.data) ? (
                    <div>
                      <p>Array with {apiResponse.data.length} items</p>
                      {apiResponse.data.length > 0 && (
                        <div className="mt-2">
                          <h4 className="font-semibold">First item:</h4>
                          <pre className="bg-gray-100 p-2 rounded mt-1 overflow-x-auto">
                            {JSON.stringify(apiResponse.data[0], null, 2)}
                          </pre>
                        </div>
                      )}
                    </div>
                  ) : typeof apiResponse.data === 'object' ? (
                    <div>
                      <p>Object with keys: {Object.keys(apiResponse.data).join(', ')}</p>
                      
                      {apiResponse.data.data && Array.isArray(apiResponse.data.data) && (
                        <div className="mt-2">
                          <h4 className="font-semibold">Data array has {apiResponse.data.data.length} items</h4>
                          {apiResponse.data.data.length > 0 && (
                            <div className="mt-2">
                              <h4 className="font-semibold">First item:</h4>
                              <pre className="bg-gray-100 p-2 rounded mt-1 overflow-x-auto">
                                {JSON.stringify(apiResponse.data.data[0], null, 2)}
                              </pre>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <p>{String(apiResponse.data)}</p>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ApiDebugTool;
